import { aboutTimeline, siteInfo } from '@/mocks/site';

export default function AboutHero() {
  return (
    <section className="w-full bg-background-100 border-b border-background-200 archive-grid">
      <div className="w-full px-4 md:px-8 py-10 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-7">
            <p className="font-label text-xs tracking-[0.25em] text-primary-600 mb-3">
              ABOUT US / 关于我们
            </p>
            <h1 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight">
              关于{siteInfo.brand}
            </h1>
            <p className="mt-5 text-sm md:text-base text-foreground-700 leading-loose">
              {siteInfo.brand}是一个专注爆料短剧的内容对照站。我们不做剧评，也不做热点追踪，只做一件相对枯燥的事：把一部剧的取材来源、原型人物、改编幅度和片尾声明拆开，摊在纸面上，让观众自己判断。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-loose">
              在我们看来，「根据真实事件改编」这句话本身不提供任何信息量，真正有用的是它后面那半句——人物改了多少、情节补了多少、程序简化到什么程度。把这半句讲清楚，才是这份档案存在的意义。
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <span className="px-3.5 py-2 rounded-md bg-background-50 border border-background-300 text-xs text-foreground-700 whitespace-nowrap">
                内容比对型档案站
              </span>
              <span className="px-3.5 py-2 rounded-md bg-background-50 border border-background-300 text-xs text-foreground-700 whitespace-nowrap">
                信源分级标注
              </span>
              <span className="px-3.5 py-2 rounded-md bg-background-50 border border-background-300 text-xs text-foreground-700 whitespace-nowrap">
                判定可复核
              </span>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <h2 className="font-heading text-base font-bold text-foreground-950 mb-5 flex items-center gap-2">
                <i className="ri-flow-chart text-primary-600"></i>
                我们是怎么走到今天的
              </h2>
              <ol className="relative border-l border-background-300 ml-1.5 space-y-6">
                {aboutTimeline.map((item, idx) => (
                  <li key={item.time} className="pl-6 relative">
                    <span
                      className={`absolute -left-[7px] top-1.5 w-3.5 h-3.5 rounded-full border-2 border-background-50 ${
                        idx === aboutTimeline.length - 1 ? 'bg-primary-500' : 'bg-accent-400'
                      }`}
                    ></span>
                    <p className="font-label text-xs text-primary-600">{item.time}</p>
                    <p className="mt-1 font-heading text-sm font-bold text-foreground-950">
                      {item.title}
                    </p>
                    <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}